/**
 * Animatable property names the Designer offers under wf:transform and
 * wf:style. A leaf module so designerInvariants.ts (the per-key allowlist) and
 * customProperties.ts (the names wf:custom-property must not take over) read
 * one list without importing each other.
 */
export const TRANSFORM_ACTION_PROPERTIES: readonly string[] = [
  'opacity',
  'autoAlpha',
  'display',
  'x',
  'y',
  'xPercent',
  'yPercent',
  'scale',
  'scaleX',
  'scaleY',
  'z',
  'skewX',
  'skewY',
  'rotation',
  'rotationX',
  'rotationY',
  'transformPerspective',
  'transformOrigin',
  'width',
  'height',
];

export const STYLE_ACTION_PROPERTIES: readonly string[] = [
  'backgroundColor',
  'borderColor',
  'color',
  'zIndex',
  'position',
  'overflow',
  'pointerEvents',
];
